<template>
  <div class="project-edit">
    <div class="detail-header">
      <h2>{{projectModel.name}}</h2>
      <div class="header-actions">
        <ButtonGroup style="margin-right: 10px">
          <Button type="info" ghost
            @click="goToGuaranteeList">
            <Icon type="ios-navigate" />
            查看保函</Button>
          <Button type="primary" ghost
            @click="getProjectDetail">
            <Icon type="md-refresh" />
            刷新</Button>
        </ButtonGroup>
      </div>
    </div>
    <Row :gutter="16">
      <i-col span="24">
        <table class="brief-table">
          <tbody>
            <tr>
              <td class="title">名称</td>
              <td colspan="3">{{projectModel.name}}</td>
            </tr>
            <tr>
              <td class="title">项目立项备案号</td>
              <td>{{projectModel.filingNo}}</td>
              <td class="title">规划许可证号</td>
              <td>{{projectModel.planLicenseNo}}</td>
            </tr>
            <tr>
              <td class="title">施工许可证号</td>
              <td>{{projectModel.constrLicenceNo}}</td>
              <td class="title">土地使用证编号</td>
              <td>{{projectModel.landLicenceNo}}</td>
            </tr>
            <tr>
              <td class="title">类型</td>
              <td>{{getPrjType(projectModel.type).join('/')}}</td>
              <td class="title">项目所在地</td>
              <td>{{projectModel.cityName}}</td>
            </tr>
            <tr>
              <td class="title">工程造价(元)</td>
              <td><h3 style="display:inline-block"> {{`¥ ${projectModel.cost}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3></td>
              <td class="title">建设规模</td>
              <td>{{projectModel.area}}</td>
            </tr>
            <tr>
              <td class="title">开竣工工日期</td>
              <td>{{require('moment')(projectModel.startdate).format('YYYY-MM-DD')}} 至 {{require('moment')(projectModel.finishdate).format('YYYY-MM-DD')}}</td>
              <td class="title">工期(天)</td>
              <td>{{projectModel.duration}}</td>
            </tr>
            <tr>
              <td class="title">质量要求</td>
              <td colspan="3">{{projectModel.qualityRequirement}}</td>
            </tr>
          </tbody>
        </table>
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'project-detail',
  props: {
  },
  data () {
    return {
      loading: false,
      projectModel: {
        id: null,
        name: null,
        type: null,
        filingNo: null,
        planLicenseNo: null,
        constrLicenceNo: null,
        landLicenceNo: null,
        cityCode: null,
        cityId: null,
        area: null,
        cost: null,
        site: null,
        startdate: null,
        finishdate: null,
        duration: null,
        qualityRequirement: null
      },
      prjTypes: []
    }
  },
  watch: {
  },
  mounted () {
    if (this.$route.params.projectId) {
      this.getProjectDetail()
    } else {
      this.$Message.error('参数错误!')
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getPrjType (type) {
      let prjType
      if (!this.prjTypes.length) {
        this.initPrjTypes().then((types) => {
          prjType = types.find(o => o.tid === parseInt(type))
        })
      } else {
        prjType = this.prjTypes.find(o => o.tid === parseInt(type))
      }
      if (prjType) {
        let prjTypeCur = [prjType.prjType]
        if (prjType.parentNode) {
          let parentNode = this.prjTypes.find(o => o.tid === prjType.parentNode)
          prjTypeCur.splice(0, 0, parentNode.prjType)
        }
        return prjTypeCur
      } else {
        return []
      }
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    goToGuaranteeList () {
      this.$router.push({name: 'guarantee-list', query: {prjId: this.$route.params.projectId}})
    },
    getProjectDetail () {
      this.$Spin.show()
      Api.Project.getProject(this.$route.params.projectId).then(detail => {
        console.log(detail)
        this.projectModel = detail
        this.projectModel.cost = detail.cost / 100
        this.projectModel.daterange = [detail.startdate, detail.finishdate]
        this.$Spin.hide()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-header {
  margin-bottom: 20px;
  .header-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
}

</style>
